import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EContractType } from '../../../packages/api-models/common/json_query';

export const selectContract = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('contract')(jsonQuery) as EContractType[] | null,
);
